<ng-container *ngIf="isMobile">
  <div fxLayout="row">
    <ngx-skeleton-loader
      class="advanced-carousel-skeleton"
      animation="progress"
      [theme]="{ 'height.px': 375 }"
    ></ngx-skeleton-loader>
  </div>
</ng-container>

<ng-container *ngIf="isTablet">
  <div fxLayout="row">
    <ngx-skeleton-loader
      class="advanced-carousel-skeleton"
      animation="progress"
      [theme]="{ 'height.px': 355 }"
    ></ngx-skeleton-loader>
  </div>
</ng-container>

<ng-container *ngIf="isDesktop || isLandScapeTablet">
  <div fxLayout="row">
    <ngx-skeleton-loader
      class="advanced-carousel-skeleton"
      animation="progress"
      [theme]="{ 'height.px': 300 }"
    ></ngx-skeleton-loader>
  </div>
</ng-container>
